/* eslint-disable require-jsdoc */

'use strict';

const tagmanagerBookAppoitment = require('int_analytics/tagmanagerBookAppoitment');

function buildRecaptchaV3() {
    $('#googleRecaptchaV3').css('display', 'block');
    var siteKey = $('#google-recaptcha-main').data('google-recaptchav3-key');
    // eslint-disable-next-line no-undef
    widgetId1 = grecaptcha.ready(function () {
        try {
        // eslint-disable-next-line no-undef
            grecaptcha.render('googleRecaptchaV3', {
                sitekey: siteKey
            });
        } catch (err) { /* empty */ }
    });
}

// Handle reCaptcha behavior, calling v3.
function getRecaptchaResponse() {
    return new Promise(function (resolve, reject) {
        if ($('#google-recaptcha-main').data('google-recaptchav3-enabled') || $('#login-google-recaptcha-main').data('google-recaptchav3-enabled')) {
            // eslint-disable-next-line no-undef
            grecaptcha.ready(function () {
                // eslint-disable-next-line no-undef
                grecaptcha.execute($('#google-recaptcha-main').data('google-recaptchav3-key'), {
                    action: 'submit'
                }).then(function (token) {
                    $.ajax({
                        url: $('#google-recaptcha-main').data('google-recaptchav3-url'),
                        method: 'POST',
                        dataType: 'json',
                        data: {
                            token: token
                        },
                        success: function (responseData) {
                            if (responseData.statusCode === 200) {
                                if (responseData.data.score > Number($('#google-recaptcha-main').data('google-recaptchav3-score'))) {
                                    if ($('#google-recaptcha-main').data('google-recaptchav3-enabled') || $('#login-google-recaptcha-main').data('google-recaptchav3-enabled')) {
                                        tagmanagerBookAppoitment.captchaVerified();
                                        resolve(true);
                                    }
                                } else {
                                    resolve(false);
                                }
                            } else {
                                reject();
                            }
                        }
                    });
                });
            });
        }
    });
}

module.exports = {
    getRecaptchaResponse: getRecaptchaResponse,
    buildRecaptchaV3: buildRecaptchaV3
};
